import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import vuex from 'vuex'
import store from './store/store'

import 'simplebar';

import imageLoad from './directives/imageLoad';
Vue.directive("lazyload", imageLoad);

Vue.use(vuex)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store
}).$mount('#app')
